import Vue from "vue";
import * as moment from "moment";
import { Component } from "vue-property-decorator";
import { EventBus } from "../Controls/EventBus";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EntreeSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/EntreeSalarieDto";
import { FiltreEntreeSortie } from "../../shared/Enums/listeEntreesSortiesSalarie/filtreEntreeSortie";
import { ParametresInstance } from "../Controls/Parameters";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import ModalPropositionsEntreeSalarie from "../modalComponents/modalPropositionsEntreeSalarie/modalPropositionsEntreeSalarie";
import { Dictionary } from "vue-router/types/router";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import formulaireEntreeSortieHelper from "../../Helper/formulaireEntreeSortieHelper";
import DataTestIDHelper from "../../Helper/DataTestID/DataTestIDHelper";

@Component({
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as ListeEntreesSalarieComponent);
			vm.fetchData();
		});
	},
	beforeRouteUpdate(to, from, next) {
		next(v => {
			const vm = v as ListeEntreesSalarieComponent;
			vm.fetchData();
		});
	},
	components: {
		ModalPropositionsEntreeSalarie: require("../modalComponents/modalPropositionsEntreeSalarie/modalPropositionsEntreeSalarie.vue.html")
	}
})
export default class ListeEntreesSalarieComponent extends Vue {
	public entrees: EntreeSalarieDto[] = [];
	public entreesFiltred: EntreeSalarieDto[] = [];

	public currentOrderColumn = "DateCreation";
	public orderingDesc = false;

	public roles: string[] = [];
	public isAdminPst = false;
	public isUtilisateurPst = false;
	public isAdmin = false;
	public filterName = "";
    public dataReady = false;

    public filtreEtatEntree: FiltreEntreeSortie = FiltreEntreeSortie.Tout;
    public filtreEntreeSortieEnum = FiltreEntreeSortie;

    public fetchData(): void {
    	this.isAdminPst = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
    	this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);
        this.isAdmin = ParametresInstance.userHasRole(RoleConstants.Administrateur);

        if (this.isAdminPst) {
            this.filtreEtatEntree = FiltreEntreeSortie.AValider;
        }

        ServicesFactoryInstance.EntreeSalarieService.getEntreesSalarie(data => {
    		this.entrees = data;
    		this.entreesFiltred = data;
    		this.getClassOfOrder(this.currentOrderColumn, true);
    		this.doFilter();
    		this.dataReady = true;
    	});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
    }

    public getEtatDemandeEtat(estSoumise: boolean, estValidee: boolean): FiltreEntreeSortie {
        return formulaireEntreeSortieHelper.getEtatDemandeEtat(estSoumise, estValidee);
    }

    public getEtatDemandeString(EstSoumise: boolean, EstValidee: boolean): string {
        return formulaireEntreeSortieHelper.getEtatDemandeString(EstSoumise, EstValidee);
    }

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.entreesFiltred != undefined) {
    		this.entreesFiltred.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
    				return (orderingDesc ? -1 : 1);
    			}
    			if (a[columnName] > b[columnName]) {
    				return (orderingDesc ? 1 : -1);
    			}

    			return 0;
    		});
    	}
	}

    public doFilter(): void {
        this.entreesFiltred = this.entrees;
        //Filtre de recherche
        if (this.filterName) {
            this.entreesFiltred = this.entreesFiltred.filter(s => (s.Nom != undefined && (s.Nom.toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.Prenom != undefined && s.Prenom.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.Id != undefined && s.Id.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.DateModification != undefined && moment.utc(s.DateModification).format("DD/MM/YYYY HH:mm").toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.DateCreation != undefined && moment.utc(s.DateCreation).format("DD/MM/YYYY HH:mm").toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0))
            );
        }

        //Filtre par état
        this.entreesFiltred = this.entreesFiltred.filter(s =>
            this.filtreEtatEntree == FiltreEntreeSortie.Tout
            || this.filtreEtatEntree == this.getEtatDemandeEtat(s.EstSoumise, s.EstValidee));
    	this.doOrder();
	}

	public ajouterEntree() {
    	const modal = this.$refs.modalPropositionsEntreeSalarie as ModalPropositionsEntreeSalarie;
    	if (modal == undefined) {
			return;
		}
    	modal.init();
	}

	public ouvrirEntree(id: number, nom: string, prenom: string, civilite: string): void {
        this.openEntreeSalarie(id, nom, prenom, civilite, false)
    }

    public visualiserEntree(id: number, nom: string, prenom: string, civilite: string): void {
        this.openEntreeSalarie(id, nom, prenom, civilite, true)
    }

    //Ouvre l'entrée avec les informations voulu
    public openEntreeSalarie(id: number, nom: string, prenom: string, civilite: string, readonly: boolean): void {
        EventBus.NavigateTo({ path: "/entreeSalarie/" + id, query: { titre: civilite + " " + nom + " " + prenom } });
    }

	public creerEntreeSalarie(idSalarie?: number): void {
		const entreeSalarieQuery: Dictionary<string> = {};
    	entreeSalarieQuery.titre = "AJOUT D'ENTRÉE";
    	if (idSalarie != undefined && idSalarie > 0) {
			entreeSalarieQuery.idSalarie = idSalarie.toString();
		}

    	EventBus.NavigateTo({ path: "/entreeSalarie/" + 0, query: entreeSalarieQuery });
	}

	public deleteItem(id: number): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment supprimer cette entrée ?",
    		callBackYes: () => {
    			ServicesFactoryInstance.EntreeSalarieService.deleteEntreeSalarie(id, () => {
    				NotificationServiceInstance.SendSuccess("Entrée supprimée avec succès.");
    				this.fetchData();
    			});
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

    //On peut supprimer une entrée si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    public canSupprimer(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canSupprimerWithRole(EstSoumise, EstValidee, this.isAdminPst, this.isAdmin, this.isUtilisateurPst)
    }

    //On peut modifier une entrée si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    public canModifier(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canModifierWithRole(EstSoumise, EstValidee, this.isAdminPst, this.isAdmin, this.isUtilisateurPst)
    }

    //On peut visualiser une entrée si état = Validees ou si on est utilisateur PST + état = A valider
    public canVisualiser(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canVisualiserWithRole(EstSoumise, EstValidee, this.isAdmin, this.isUtilisateurPst)
    }

    public getEntryRequestState(entree: EntreeSalarieDto) : string
    {
        return DataTestIDHelper.getEntryRequestState(entree);
    }
}



// WEBPACK FOOTER //
// ./src/components/listeEntreesSalarie/listeEntreesSalarie.ts